var _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fillRule: "evenodd",
      fill: "#4E565A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.7832 15.494c-2.8 0-4.48-3.0516-2.96-5.3804 1.44-2.3288 4.96-2.0879 6.08 0.40152h7.3599l1.52 1.5258-1.52 1.4455-1.04-0.96365-0.95999 0.96365-1.04-0.96365-0.95999 0.96365-1.04-0.96365-0.95999 0.96365h-1.36c-0.56 1.2849-1.76 2.0879-3.12 2.0076zm-1.04-2.4894c1.36 0 1.36-2.0076 0-2.0076-1.28 0-1.28 2.0076 0 2.0076z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOver);
export default __webpack_public_path__ + "static/media/key-over.829e3ea8bd9d9b11fa9e8bd6f5301c03.svg";
export { ForwardRef as ReactComponent };